// extracted by mini-css-extract-plugin
export default {"container":"Ho-z","ratingLayout":"Io-z","ratingLabel":"Jo-z","nonInteractiveRatingLabel":"Ko-z"};